import { Component, OnInit } from "@angular/core";
import {
	ElementRef,
	Renderer2,
} from "@angular/core";
import { Router } from "@angular/router";
import { FormGroup, FormBuilder, Validators, AbstractControl, ValidationErrors } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { Input, EventEmitter, Output, OnDestroy, ChangeDetectionStrategy } from "@angular/core";

//import { KioskService } from "../kiosk.service";
import { LocalStorageService } from "@dodo/local-storage/trycatch-local-storage.service";
import { QualificationError } from "app/_core/_models/qualification.models";
import { Auth0User } from "app/_core/services/models/auth0-user.model";
import { Auth0Service } from "app/_core/services/auth0.service";
import { DodoService } from "app/_core/services/models/dodo-service.model";
import { FormStatus } from "app/_core/services/models/types";
import { WebApiService, JsonFileService } from "_libs/web-api";
import { filter, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { LocalStorageKeys } from "app/_core/services/local-storage-state-restor.service";
// import { Zeus } from "app/_core/services/models/zeus.models";
import { DebugService } from "app/_core/services/debug.service";
import { Global } from "app/_core/services/models/global";
import { TealiumService } from "tealium/services/tealium.service";
import { BoboPaymentComponent } from "../bobo-payment/bobo-payment.component";
import { BoboPaymentService } from "../bobo-payment-service";






declare let Payment: any;

const IFRAME_CONTENT_LOADING = "iframe content for payment page is loading.";
const IPSI_FORM_RENDERED = "The payment form has rendered.";
const IPSI_SUBMISSION_INIT = "The payment form has been submitted.";
const PAYMENT_OUTCOME_RECEIVED = "Payment outcome for the transaction.";

@Component({
    selector: "bobo-payment-details",
    templateUrl: "./bobo-payment-details.component.html",
    styleUrls: ["./bobo-payment-details.component.scss"],
    standalone: false
})
export class BoboPaymentDetailsComponent implements OnInit, OnDestroy {
	public _paymentDeclined = false;

	public _paymentErrorMessage =
		"Your payment has been unsuccessful, please try again. If this error persists, please contact our sales team on 13 36 36";
	private __ipsiSubmitPaymentNotTriggered: any;
	public iframePayment: any;

	public iframe: any ; // Zeus.Payment.iFrameUrlResponse;

	_appearance = "fill";
	_form: FormGroup;
	public showPaymentScreen = false;
	public _virtualKeyboardIframe = false;
	public busy = false;
	private __status: FormStatus = "INVALID";
	private _refId: string;
	public reload = false;
	paymentSuccessful = false;
	paymentError = "";
	public error = false;
	public errorMessage = "Sometihing went wrong. Please go back to enter the reference number again.";

	set Status(status: FormStatus) {
		if (status !== this.__status) {
			this.__status = status;
			//this.isValid.emit(this.__status);
		}
	}
	
	set Busy(busy: boolean) {
		this.busy = busy;
		//this.busyStatus.emit(busy);
	}

	destroyed$ = new Subject<boolean>();
	private entry = "manual";


	constructor(
		private __fb: FormBuilder,
		private __localstorage: LocalStorageService,
		private __webApiService: WebApiService,
		private log: DebugService,
		private renderer: Renderer2,
		private er: ElementRef,
		private __tealiumService: TealiumService,
		private __boboPaymentService: BoboPaymentService,
		private __router: Router
	) {
		const query_params = this.__localstorage.getFromSessionStorage("query-params");
		console.log("queryParams", query_params);
		if (query_params && query_params.refId) {
			this._refId = query_params.refId;
			this.entry = "url";
			this.loadIframe();
		} else {
			this.entry = "manual";
			this.__boboPaymentService.paymentReference$
			.pipe(filter(ref => !!ref), takeUntil(this.destroyed$))
			.subscribe(ref => {
				this._refId = ref;
				this.loadIframe();
			});
		}
		if (window.addEventListener) {
			window.addEventListener(
				"message",
				this.__iframeMessageHandler.bind(this),
				false
			);
		} else {
			(<any>window).attachEvent(
				"onmessage",
				this.__iframeMessageHandler.bind(this)
			);
		}
		this.__buildForm();
	}

	ngOnInit(): void {
	}

	private __buildForm(): void {
		this._form = this.__fb.group({
			reference: [
				undefined
			]
		});
	}

	ngOnDestroy() {
		this.destroyed$.next(true);
		this.destroyed$.complete();
	}

	public loadIframe() {
		this.__initializePayment();
	}

	public reloadIFrame() {
		this.reload = false;
		this.__initializePayment();
		this.log.dev("calling reload iframe here ....: 0");
	}

	public reloadIFrameWhenError() {
		this.reload = true;
		this.__initializePayment();
	}

	private get _previousIframe(): HTMLIFrameElement {
		this.log.dev("previous iframe html from global: ", Global.iframeHtml);
		return Global.iframeHtml;
	}

	private __iframeMessageHandler(event: any) {
		if (this.iframe) {
			if (this.iframe.hostNameField.indexOf(event.origin) > -1) {
				this.__ipsiMessagesHandler(event);
			}
		}
	}

	private __ipsiMessagesHandler(event: any) {
		this.log.dev("credit-card: handle ipsi events : ", event);
		if (event && event.data) {
			const data = JSON.parse(event.data);
			this.log.dev("ipsi iframe data json :", data);
			this._virtualKeyboardIframe = !!(data?.resize?.height > 229);
			if (data?.info === "Payment outcome for the transaction.") {
				this.log.dev("ipsi iframe data json : with body", data);
			}
			console.log("%c data ", "background: #222; color: #bada55");
			if (data.info) {
				if (data.info === IFRAME_CONTENT_LOADING) {
					// loading iframe content
					this.log.dev("credit-card: iFrame content loading...");
					this.Status = "INVALID";
				} else if (data.info === IPSI_FORM_RENDERED) {
					// iFrame is loaded successfully, may hide loader (advised to show loader when building iframe)

					this.log.dev("credit-card: ipsi form rendered...");
					setTimeout(() => {
						this.Busy = false;
					});
					this.Status = "VALID";
					// this.ipsiEvent.emit(Zeus.IPSIEvents.IPSI_LOADED);
				} else if (data.info === IPSI_SUBMISSION_INIT) {
					// iFrame submission initialized, may want to show loader at this point

					this.Status = "PENDING";
					clearTimeout(this.__ipsiSubmitPaymentNotTriggered);
					this.log.dev(
						"credit-card: iFrame submission initialized..."
					);
				} else if (data.info === PAYMENT_OUTCOME_RECEIVED) {
					this.log.dev(
						"credit-card: iFrame submission is successful..."
					);
					// , may hide loader
					if (data.cardToken && data.cardToken !== "{cardToken}" && data?.body.toLowerCase() === "approved" && data?.success) {
						this.log.dev("credit-card: Tokenization completed successfully...");
						// this.__tealiumService.reportPayment({
						// 	tealium_event: "ipsi-payment-successful"
						// });
						this.paymentSuccessful = true;
						const url = `/thankyou`;
						this.__router.navigate([url]);
					} else {
						// cardToken not returned, show error message
						console.error("!!!cardToken not returned!!!");
						this.paymentError = "cardToken not returned";
						this.Status = "VALID";
							console.error("IPSI response nbn", data);
							if (data?.responseCode == "51") {
								this._paymentErrorMessage = `Unable to process payment due to insufficient funds. Try a different card or refer to your card issuer [Ref: ${data?.merchantReference}]`;
							} else if (data?.responseCode == "99" || (data?.responseCode > 700 && data?.responseCode != 709)) {
							this._paymentErrorMessage = `We are currently having trouble processing your payment, please check your account before trying again later. [Ref: ${data?.merchantReference}]`;
							} else if (data?.responseCode == "709" || (data?.responseCode < 100 && data?.responseCode != 51 || data?.responseCode != 99)) {
							this._paymentErrorMessage = `Unable to process payment due to card issue. Try a different card or refer to your card issuer [Ref: ${data?.merchantReference}]`;
							} else if (data?.responseCode == "14" || data?.responseCode == "33") {
							this._paymentErrorMessage = "Incorrect card details. Please check and try again. If this error persists, please contact our sales team on 131 789";
							} else {
							this._paymentErrorMessage = `We are currently having trouble processing your payment, please check your account before trying again later. [Ref: ${data?.merchantReference}]`;
							}
							this._paymentDeclined = true;
							// this.__tealiumService.reportPayment({
							// 	ipsi_card_category: data?.cardCategory,
							// 	ipsi_card_schema: data?.cardSchema,
							// 	ipsi_response_code: data?.responseCode,
							// 	tealium_event: "flash_message",
							// 	event_trigger: "error",
							// 	error_code: "DSF_CART_CC_03",
							// 	error_description: this._paymentErrorMessage,
							// });
							this.reloadIFrame();
					}
				}
			}
		}
	}

	private __initializePayment() {
		this.Busy = true;
		this.Status = "INVALID";

		const payload = {
			"code": this._refId
		};
		this.__webApiService.postMS("payment/verification", payload)
			.pipe(takeUntil(this.destroyed$))
			.subscribe(
				(iframe: any) => {
					// this store the latest iframeUrl since we need transactionId in make-payment step
					if (iframe && iframe.code && iframe.status && iframe.status == "failure") {
						if (iframe.code == "Time limit exceeded") {
							this.Busy = false;
							this.Status = "VALID";
							this.error = true;
							if (this.entry == "url") {
								this.errorMessage = "This link has expired. Please ask the Sales Representative to resend the sms.";
							} else {
								this.errorMessage = "The Reference Id you entered has expired. Please go back to enter the correct one, by checking with the Sales Representative.";
							}
							this.__tealiumService.reportBoboPaymentVerificationError(this.errorMessage, "DSF_BOBO_PAYMENT_02");
						} else if (iframe.code == "This is already completed") {
							this.Busy = false;
							this.Status = "VALID";
							this.error = true;
							if (this.entry == "url") {
								this.errorMessage = "Payment is already made with this link. Please check with the Sales Representative, to get a new link.";
							} else {
								this.errorMessage = "Payment is already made with this Reference Id. Please check with the Sales Representative for a new Reference Id.";
							}
							this.__tealiumService.reportBoboPaymentVerificationError(this.errorMessage, "DSF_BOBO_PAYMENT_03");
						}
					} else {
						this.setIframe(iframe);
					}
				},
				(error) => {
					this.Busy = false;
					this.Status = "VALID";
					this.error = true;
					this.errorMessage = "Invalid reference number. Please go back to enter the correct reference number.";
					this.__tealiumService.reportBoboPaymentVerificationError(this.errorMessage, "DSF_BOBO_PAYMENT_01");
					this.raiseErrorApiFailed();
				}
			);
	}

	private setIframe(iframe: any): void {
		this.iframe = iframe;
		this.__localstorage.setInSessionStorage(LocalStorageKeys.iframeUrl, iframe);
		this.renderIframe();
	}

	private raiseErrorApiFailed(code: string = "") {
		const error = <QualificationError>{
			title: `Oops`,
			msg: `
				Oops, it looks like there is a hitch with getting you started. Please try refreshing the page or for help call 13DODO.
				<p class="order-no">Error Code: DSF_BROADBAND_MULEIFRAME_01</p>
				`,
			errorCode: "DSF_BROADBAND_MULEIFRAME_01",
			errorDescription:
				"Dodo Sales Funnel: Broadband: MULEIFRAME: Server failed to respond api call for MULEIFRAME",
			finePrint: "",
			enableRequestCallback: true,
			category: "MULEIFRAME_failed_500",
			image: "/assets/img/dodo_sheepish.png",
			tealiumErrorCode: "DSF_BROADBAND_MULEIFRAME_01",
			tealiumErrorDescription:
				"Dodo Sales Funnel: Broadband: MULEIFRAME: Server failed to respond api call for MULEIFRAME",
		};
	}

	private renderIframe() {
		this.Busy = true;

		// bruce ...
		const prevIframeHtml: any = this._previousIframe;

		this.log.dev("credit-card: Calling Payment method ...");
		if (prevIframeHtml) {
			this.iframePayment = Payment(prevIframeHtml);
		} else {
			this.iframePayment = Payment();
		}

		const buildParams = {
			host: this.iframe.fullUrlField,
			paramString: this.iframe.paramsField,
			attributes: {
				id: "PaymentIframe",
				scrolling: "no",
				'http-equiv':"Content-Security-Policy",
				content: `default-src 'self'; script-src 'self'; frame-src https://payments.enterprisesecure.com.au; 
					connect-src 'self' https://payments.enterprisesecure.com.au; object-src 'none'; base-uri 'none';
					form-action https://payments.enterprisesecure.com.au; style-src 'self' 'unsafe-inline'; font-src 'self';`,
				style: "width: 100%; border-width: 0; overflow:hidden;"
			}
		};

		this.log.dev("credit-card: iframePayment Obj :", this.iframePayment);

		this.iframePayment.build(buildParams);
		this.log.dev(
			"credit-card: Calling iframe method of iframePayment Object"
		);
		const iframeNode = this.iframePayment.iframe();
		this.log.dev("credit-card: iframe html : ", iframeNode);
		this.appendIpsiIframe(iframeNode);
	}

	private appendIpsiIframe(html: HTMLIFrameElement) {
		this.log.dev("credit-card: iframe html to append :", html);
		this.log.dev("credit-card: native element : ", this.er.nativeElement);
		const ipsiContainer = this.er.nativeElement.querySelector(
			"#ipsi-container"
		);
		this.log.dev("credit-card: ipsi container : ", ipsiContainer);
		this.renderer.appendChild(ipsiContainer, html);
		this.log.dev("credit-card: adding iframe to dom");
		Global.iframeHtml = html;
		// this.store.dispatch(new PaymentIframeLoaded(html));
	}

	public submitIpsiFrame() {
		this.log.dev(
			"credit-card: calling iframePayment object submitIframe()"
		);
		this.iframePayment.submitIframe();
		this.Busy = true;
		this.Status = "PENDING";

		this.__ipsiSubmitPaymentNotTriggered = setTimeout(() => {
			this.Busy = false;
			this.Status = "VALID";
		}, 1000);
	}

	public backToReference() {
		const url = `/payment`;
		this.__router.navigate([url]);
	}

}
